import React, { useState } from 'react';

import { useQuery } from 'react-query';
import { fetchPaginatedGroups } from 'api/groups';

import { washHub } from 'store/slices';
import { useWashHubListener } from 'hooks';

import { GroupsProps } from './Groups.props';

import GroupsView from './Groups.view';

const GroupsContainer = (props: GroupsProps) => {
  const [page, setPage] = useState<number>(1);

  const washHubId = washHub.selectors.useSelectedWashHubId();
  const isWashHubIdValid = washHub.selectors.useIsWashHubIdValid();
  const queryKey = [`fetch-groups-${washHubId}`, page];

  const queryFn = () =>
    fetchPaginatedGroups({
      page,
      limit: 10,
      washHub: washHubId,
    });

  const options = {
    enabled: isWashHubIdValid,
    keepPreviousData: true,
  };

  const { data, isFetching, isLoading } = useQuery(queryKey, queryFn, options);

  useWashHubListener(() => {
    setPage(1);
  });

  const groups = data?.items || [];
  const totalCount = data?.total || 0;
  const totalPages = data?.totalPages || 0;

  const pagination = {
    page,
    setPage,
    totalCount,
    totalPages,
  };

  const _props = {
    groups,
    isLoading: isLoading || isFetching,
    pagination,
  };

  return <GroupsView {..._props} />;
};

export default GroupsContainer;
